module.exports = __webpack_public_path__ + "media/images/icons/icon-document-727c7ab905dd4c3796a2fb57fb59131f.svg";